<template>
  <div>
    <div class="sidebar__media" v-if="keySidebarActive === 'media'">
      <div class="sidebar__media__head">
        <div class="book-viewer__sidebar__contents__wrap">
          <h3 class="sidebar__title">Học liệu <span class="secondary-color-txt font-size-18 font-sanpro">{{ versionApp }}</span></h3>
          <div class="sidebar__media__form">
                <div class="input-custom-icon">
                  <!-- @keyup.prevent="handleFilter" -->
                  <input type="text" name="search" class="form-h30 border-rd-20 bg-color-light border-0 full-width" placeholder="Tìm kiếm" v-model.lazy="keyword" v-debounce="300" />
                  <i class="icon-search primary-color font-size-16"></i>
                </div>
            </div>
        </div>
      </div>
      <div class="sidebar__media__result">
        <vue-custom-scrollbar class="scroll-area scroll-area__sidebar" :settings="settingsViewBookSidebar">
          <div class="book-viewer__sidebar__contents__wrap">
            <div class="sidebar__media__list">
              <div 
                class="item position-rel" 
                v-for="(item, index) of listMediaPage" 
                :key="index"
                v-show="(keyFilterMedia === '' || keyFilterMedia === checkTypeDocs(item.linkUrl))"
                :class="{'item--lock': (!item.isShowFree || item.isShowFree === 0) && !ebooksDetail.actived}"
                @click="handleViewMedia(item)"
              >
                <div class="item__media position-rel"><!-- v-if="item.isShowFree && item.isShowFree !== 0 && ebooksDetail.actived" -->
                  <div class="img-wrap text-center">
                    <img v-if="item.linkUrl && checkVideo(item.linkUrl)" :src="item.posterLink ? `${urlImg}/${item.posterLink}` : img404" alt="Học liệu">
                    <PreviewAudio
                      class="evt-none"
                      v-else-if="checkAudio(item.linkUrl)" 
                      :pathView="isFullLink(item.linkUrl) ? item.linkUrl : `${appUrl}${item.linkUrl}`" 
                    />
                    
                    <img v-else :src="`${appUrl}${item.posterLink ? item.posterLink : item.linkUrl}`" alt="Học liệu">
                  </div>
                  <IconMedia class="item__icon" :dataSource="item" />
                </div>
                <h4 class="item__title font-size-15 color-light margin-0">
                  {{ item.titleLink }}
                </h4>
              </div>
            </div>
            <div v-if="isShowNoti">
              <h3 class="secondary-color-txt font-size-16 text-center">Không có học liệu</h3>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>

    <div class="sidebar-link" v-if="keySidebarActive === 'link'">
    	<div class="sidebar-link__head">
    		<div class="book-viewer__sidebar__contents__wrap">
        		<h3 class="sidebar__title">Liên kết</h3>
        	</div>
    	</div>
        <div class="sidebar__link__result">
        	<div class="book-viewer__sidebar__contents__wrap">
              <b-tabs class="sidebar__tabs">
                  <b-tab active>
                      <template v-slot:title>Sách điện tử</template>
                      <div class="book-links">
                          <vue-custom-scrollbar class="scroll-area scroll-area__sidebar" :settings="settingsViewBookSidebar">
                              <div v-if="ebooksDetailss && ebooksDetailss.bookRelates" class="item display-flex full-width" v-for="(item, index) of ebooksDetailss.bookRelates">
                                  <div class="item__img">
                                    <router-link :to="{ name: 'ebook-detail', params: { id: item.bookId, slug: item.slug }}">
                                      <img v-lazy="item.imageUrl ? handleResizeImgBook(item.imageUrl) : ''" :alt="item.name">
                                    </router-link>
                                  </div>
                                  <div class="item__content">
                                      <h4 class="item__name font-size-16 font-sanpro-semibold primary-color-txt margin-0">
                                        <router-link :to="{ name: 'ebook-detail', params: { id: item.bookId, slug: item.slug }}" class="color-inherit">{{ item.name }}</router-link>
                                      </h4>
                                      <p class="item__year font-size-14 secondary-color-txt">Tái bản: {{ item.editionYear }}</p>
                                      <router-link :to="{ name: 'ebook-detail', params: { id: item.bookId, slug: item.slug }}" target= '_blank' class="btn btn-main-light border-rd-20 font-size-15 font-sanpro-semibold">Đọc sách</router-link>
                                  </div>
                              </div>
                          </vue-custom-scrollbar>
                      </div>
                  </b-tab>
              </b-tabs>
          </div>
        </div>
    </div>

    <div class="sidebar__info" v-if="keySidebarActive === 'info'">
      <div class="sidebar__info__head">
        <div class="book-viewer__sidebar__contents__wrap">
          <h3 class="sidebar__title">Thông tin</h3>
        </div>
      </div>
      <div class="sidebar__info__result">
        <vue-custom-scrollbar class="scroll-area scroll-area__sidebar" :settings="settingsViewBookSidebar">
          <div class="book-viewer__sidebar__contents__wrap">
            <div class="sidebar__info__list">
              <div class="item">
                <div class="item__title">Chủ đề: </div>
                <div class="item__value">{{ dataInfo.topicName }}</div>
              </div>
              <div class="item">
                <div class="item__title">Bài: </div>
                <div class="item__value">{{ dataInfo.lessonName }}</div>
              </div>
              <div class="item">
                <div class="item__title">Phần: </div>
                <div class="item__value">{{ dataInfo.partName }}</div>
              </div>
              <div class="item">
                <div class="item__title">Số câu: </div>
                <div class="item__value">{{ dataInfo.totalQuestion }}</div>
              </div>
              <div class="item">
                <div class="item__title">Số câu đúng: </div>
                <div class="item__value">{{ dataInfo.totalCorrectQuestion }}</div>
              </div>
              <div class="item">
                <div class="item__title">Số câu sai: </div>
                <div class="item__value">{{ dataInfo.totalInCorrectQuestion }}</div>
              </div>
              <div class="item">
                <div class="item__title">Chưa làm: </div>
                <div class="item__value">{{ dataInfo.totalQuestionNotDone }}</div>
              </div>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
  import { STORE_KEY} from "../_store/constants";
  import { STORE_KEY as STORE_KEY_EBOOK } from '@/modules/ebooks/_store/constants'
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import { APP_CONFIG } from '@/utils/constants'
  import mixinsFiles from '@/components/content-files/mixinsFiles'
  import PreviewVideo from '@/components/content-files/PreviewVideo.vue'
  import PreviewImage from '@/components/content-files/PreviewImage.vue'
  import PreviewAudio from '@/components/content-files/PreviewAudio.vue'
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
  import { getAuth } from '@/utils/jwt'
  import { EMAIL_PUBLIC } from '@/store/auth/constants'
  import IconMedia from '@/modules/libraries/_components/list/IconMedia.vue'
  import { getMediaInBookPage } from '@/modules/ebooks/_api'
  import { getCatInfoOfExercise } from './../_api/'
  import ModalMedia from '@/modules/ebooks/_components/ebook-viewer/ModalMedia.vue'
  import debounce from "@/directives/debounce";
  import { updatecountview } from '@/store/common/api'
  import { replaceImageResize } from '@/helpers/functions'
  const img404 = require(`@/assets/images/img_404.jpg`)

  export default {
    name: 'ExerciseSidebar',
    mixins: [ mixinsFiles ],
    components: {
      vueCustomScrollbar,
      PreviewVideo,
      PreviewImage,
      PreviewAudio,
      IconMedia,
      ModalMedia
    },
    props: {
      keySidebarActive: String,
      ebooksDetail: Object,
      // listMediaPage: Array,
      pageCurr: Array,
      mediaRelate: Object,
      checkQuestionId: Object
    },
    directives: { debounce },
    data () {
      return {
        paramFethMedia:{},
        settingsViewBookSidebar: {
          maxScrollbarLength: 300
        },
        cdnUrl: APP_CONFIG.cdnUrl,
        appUrl: APP_CONFIG.bookCdnUrl,
        bookImgCdnUrl: APP_CONFIG.bookImgCdnUrl,
        urlImg: APP_CONFIG.urlPlatformCmsImg,
        keyFilterMedia: '',
        img404,
        authInfo: {},
        listMediaPage: [],
        // allMedias: [],
        dataInfo: {},
        // emailPublic: EMAIL_PUBLIC
        keyword: '',
        pageSearch: 0,
        isShowNoti: false,
        id: this.$route.params.id,
        pageChange: 0,
        pageChanges: 0
      }
    },
    computed: {
      ...mapState('auth', ['loginPopupData']),
      ...mapState('common', ['visiblePreviewSliderModal', 'versionApp', 'getInfoExcercise']),
      ...mapState(STORE_KEY_EBOOK, ['paramSearchRelateMedia']),
      ...mapGetters({
        ebooksDetailss: STORE_KEY + '/ebooksDetail',
         setCheckExcercise: 'common' + '/setCheckExcercise',
      }),
    },
    watch: {
      getInfoExcercise(newVal){
        if(newVal){
          this.handleChangePage()
          // this.getMedias()
        }
      },
      keyword: "handleFilterKeyword",
      loginPopupData (newVal) {
        if(newVal && Object.keys(newVal).length) {
          this.authInfo = newVal;
        }
      },
      keySidebarActive (newVal) {
        if (newVal === 'media') {
          this.getMedias()
        } else if (newVal === 'info') {
          this.getInfoExerciseQuestion()
        }
      },

      mediaRelate (newVal) {
        newVal && this.viewMoreMedia(newVal)
      },

      checkQuestionId (newVal) {
        if (newVal && Object.keys(newVal) && this.authInfo && this.authInfo === EMAIL_PUBLIC) {
          this.dataInfo.totalCorrectQuestion = newVal.questionCorrect
          this.dataInfo.totalInCorrectQuestion = newVal.questionInCorrect
          this.dataInfo.totalQuestionNotDone = newVal.questionNotDone
        } else if (newVal && newVal.value && this.dataInfo) {
          if (newVal.id === 0) {
            this.dataInfo.totalCorrectQuestion -= 1
            this.dataInfo.totalQuestionNotDone += 1
          } else {
            this.dataInfo.totalCorrectQuestion += 1
            this.dataInfo.totalQuestionNotDone -= 1
          }
        } else if (newVal && !newVal.value && this.dataInfo) {
          if (newVal.id === 0) {
            this.dataInfo.totalInCorrectQuestion -= 1
            this.dataInfo.totalQuestionNotDone += 1
          } else {
            this.dataInfo.totalInCorrectQuestion += 1
            this.dataInfo.totalQuestionNotDone -= 1
          }
        }
      },
      '$route.query.sach': 'getInfoBook',
      '$route.query.danhmuc': 'getInfoExerciseQuestion'
    },
    created() {
      this.authInfo = getAuth();
    },
    methods: {
      ...mapActions('auth', ['setToggleLoginForm']),
      ...mapActions('common', ['setLoading', 'setToggleModalDocSlider', 'setDocPreviewSlider', 'acSetDataBookActiveWant', 'acToggleModalActiveBook']),
      ...mapMutations(STORE_KEY_EBOOK, ['SET_PARAM_SEARCH_RELATE_MEDIA']),
      ...mapActions(STORE_KEY, ['getEBooksDetail']),

      getInfoBook () {
        this.getEBooksDetail(parseInt(this.$route.query.sach))
      },

      async getMedias () {
        let self = this
        self.listMediaPage = []
        /**
        * Params call media info:
        * bookId - bookPageId=0 - pageNo
        **/ 
        this.paramFethMedia = { bookId: self.ebooksDetail.bookId, pageNo: 0, keyword: '' };
        const requestGetMedia = await self.pageCurr.map(page => {
        this.pageSearch = page
      
          return getMediaInBookPage({...this.paramFethMedia, pageNo: page, keyword: ''}).then(res => {
            if (res && res.data && res.data.length && !res.errors) {
              res.data.map (link => {
                if (link.linkPages && link.linkPages.length > 0)
                  link.linkPages.map(media => {
                    self.listMediaPage = [...self.listMediaPage, {...media, linkPages: link.linkPages}]
                  })
              })
              this.isShowNoti = false
            } else {
              this.isShowNoti = true
            // this.listMediaPage = []
            // console.log('không có linkPages', res.data)
          }
            return {...res, pageNo: page};
          });
        });

        Promise.all(requestGetMedia)
      },
      handleFilterKeyword(){
        // JSON.stringify
        getMediaInBookPage({bookId: this.ebooksDetail.bookId, pageNo: this.pageSearch, keyword: this.keyword}).then(res => {
          if(res && res.data && res.data.length > 0){
            this.listMediaPage = res.data[0].linkPages
            this.isShowNoti = false
          } else {
            this.isShowNoti = true
            this.listMediaPage = []
          }
        })
      },
      handleChangePage(){
        // this.pageCurr.map(page => {
        //   this.pageChange = page
        // })
        // console.log('vao pageCurr', this.pageCurr);

        // this.pageChanges = this.pageCurr
        // console.log('this.setCheckExcercise', this.setCheckExcercise);
        getMediaInBookPage({bookId: this.ebooksDetail.bookId, pageNo: this.setCheckExcercise, keyword: ''}).then(res => {
          if(res && res.data && res.data.length > 0){
            this.listMediaPage = res.data[0].linkPages
            this.isShowNoti = false
          } else {
            this.isShowNoti = true
            this.listMediaPage = []
          }
        })
      },

      handleViewMedia (val) {
        
        let linkActive = val.isShowFree && val.isShowFree !== 0;
        if(this.authInfo && this.authInfo.email === EMAIL_PUBLIC && !this.ebooksDetail.actived && !linkActive) {
          this.setToggleLoginForm(true);
        } else if(!linkActive && !this.ebooksDetail.actived) {
          this.acToggleModalActiveBook(true)
        } else {
          let paramSearchCurr = {bookId: this.ebooksDetail.bookId, pageNo: val.pageNo, typeId: val.documentTypeId, pageIndex: 1, bookPageId: val.bookPageLinkId};
          this.setDocPreviewSlider(val);
          this.setToggleModalDocSlider(true);
          updatecountview(val.pageLinksId)
          // .then(res => {
          //   if(res){
          //     // console.log('res click val', res)
          //   }
          // })
          // this.SET_PARAM_SEARCH_RELATE_MEDIA({...this.paramSearchRelateMedia, ...paramSearchCurr});
        }
      },

      handleOffModal() {
        this.setDocPreviewSlider({});
        this.setToggleModalDocSlider(false);
      },

      viewMoreMedia(data) {
        let self = this;
        let paramFethMedia = { bookId: self.ebooksDetail.bookId, pageNo: data.pageNo, bookPageId: data.bookPageId, keyword: '' };
        getMediaInBookPage(paramFethMedia).then(res => {
          if(res && res.data && res.data.length > 0) {
            let mediaActive = res.data.filter(media => media.bookPageLinkId === data.bookPageLinkId);
            if(mediaActive.length > 0) {
              let dataMediaPreview = mediaActive[0];
              let indexMediaForFirst = -1;
              if(dataMediaPreview.linkPages && dataMediaPreview.linkPages.length > 0) {
                indexMediaForFirst = dataMediaPreview.linkPages.findIndex(media => media.pageLinksId === data.pageLinksId)
                if(indexMediaForFirst > -1) {
                    dataMediaPreview.linkPages.unshift(dataMediaPreview.linkPages[indexMediaForFirst])
                    dataMediaPreview.linkPages.splice(indexMediaForFirst + 1, 1);
                }
                dataMediaPreview.linkPages.map(link => link['bookPageId'] = dataMediaPreview.bookPageId)
              }
              return dataMediaPreview
            }
          }
          return;
        }).then(media => {
          self.setDocPreviewSlider(media);
        });
      },

      getInfoExerciseQuestion () {
        let bookIndexId = parseInt(this.$route.query.danhmuc) || 0
        if (bookIndexId > 0 && this.keySidebarActive) {
          getCatInfoOfExercise(bookIndexId).then(res => {
            this.dataInfo = res ? {...res} : {}
            // if (res) {
            //   this.dataInfo = {
            //     ...res
            //     // totalCorrectQuestion: this.checkQuestionId.questionCorrect,
            //     // totalInCorrectQuestion: this.checkQuestionId.questionInCorrect,
            //     // totalQuestionNotDone: this.checkQuestionId.questionNotDone
            //   }
            // } else {
            //   this.dataInfo = {}
            // }
          }).finally()
        }
      },

      handleResizeImgBook (link) {
        return replaceImageResize(link, {width: 130, height: 185})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sidebar__imgbooks{
    // height: 70vh;
    // overflow: auto;
    .img-books{
      margin-top: 20px;
    }
  }
  /* width */
  ::-webkit-scrollbar {
  width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
  background: #f1f1f1; 
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 20px;
  }
  .sidebar__media__list {
    .item {
      
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,.2);
        z-index: 1;
        @extend .effect-transition-fast;
        @extend .effect-hide-hover;
      }

      &--lock {
      //   &:before {
      //     content: '';
      //     position: absolute;
      //     top: 0;
      //     left: 0;
      //     right: 0;
      //     bottom: 0;
      //     background: rgba(0,0,0,.2);
      //     z-index: 1;
      //   }
        .item {
          &__title {
            @extend .secondary-color-txt;
          }
        }
      }

      &__title {
        z-index: 2;
      }

      &__icon {
        @extend .position-center-xy;
        z-index: 1;
        opacity: 0;
      }

      &:hover {
        &:before {
          @extend .effect-show-hover;
        }

        .item {
          &__icon {
            opacity: 1;
          }
        }
      }
    }
  }

  .sidebar__info__list {
    .item {
      @extend .display-flex;
      margin-bottom: 15px;

      &__title {
        width: 45%;
        margin-right: 1%;
        @extend .secondary-color-txt;
        @extend .font-size-15;
        @extend .font-sanpro-semibold;
      }

      &__value {
        width: 54%;
        @extend .font-size-16;
        @extend .font-sanpro-light;
        @extend .primary-color-txt;
      }
    }
  }
</style>